import { useEffect, useState } from 'react';

import style from '@styles/_const.scss';

const desktopWidth = parseInt(style.desktop, 10);

const useIsDesktop = () => {
  const [isDesktop, setIsDesktop] = useState(window.innerWidth > desktopWidth);

  useEffect(() => {
    const checkIsDesktop = () => setIsDesktop(window.innerWidth > desktopWidth);
    window.addEventListener('resize', checkIsDesktop);
    return () => window.removeEventListener('resize', checkIsDesktop);
  }, []);

  return isDesktop;
};

export default useIsDesktop;
